import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { HttpErrorResponse } from "@angular/common/http";
import { CoreErrorDialogComponent } from "./error-conflict.component";
import { Router } from "@angular/router";

@Injectable()
export class ErrorConflictDialogService {
	constructor(private dialog: MatDialog, private router: Router) {}
	openDialog(httpResponse: HttpErrorResponse) {
		if (httpResponse && httpResponse.status !== null) {
			if (httpResponse.status.toString().indexOf("409") > -1) {
				this.dialog
					.open(CoreErrorDialogComponent, {
						data: httpResponse,
					})
					.afterClosed()
					.subscribe((reload: boolean) => {
						if (reload) {
							document.location.reload();
						}
					});
			}
		}
	}
}
